import DatabaseModel from './DatabaseModel.js';

var ItemCaracteristica = Object.create(DatabaseModel);

ItemCaracteristica.model = 'itemcaracteristicas';
ItemCaracteristica.modelFront = 'itemcaracteristicas';

ItemCaracteristica.importExcel = function(file, mode) {
    var self = this;
    var formData = new FormData();
    formData.append('file', file);
    if (mode) formData.append('mode', mode);
    return new Promise(function(resolve, reject) {
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/import?mode=' + (mode || 'UPSERT'),
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: formData
        };
        // Inyectar Authorization manualmente — sendRequest no se usa porque hay FormData.
        try {
            var session = JSON.parse(localStorage.getItem('session') || 'null');
            var token = session && (session.token || session.access_token);
            if (token) {
                params.headers = { Authorization: 'Bearer ' + token };
            }
        } catch (e) {}
        self.request.promise(params).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

ItemCaracteristica.downloadExcel = function() {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/export';
    var name = 'item_caracteristicas.xlsx';
    return new Promise(function(resolve, reject) {
        var params = {
            url: url,
            method: 'GET',
            crossDomain: true,
            xhrFields: { responseType: 'arraybuffer' },
            success: function(data) {
                var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, name);
                } else {
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.target = '_blank';
                    link.click();
                    URL.revokeObjectURL(link.href);
                }
                resolve();
            },
            error: function(error) { reject(error); }
        };
        try {
            var session = JSON.parse(localStorage.getItem('session') || 'null');
            var token = session && (session.token || session.access_token);
            if (token) params.headers = { Authorization: 'Bearer ' + token };
        } catch (e) {}
        self.request(params);
    });
};

export default ItemCaracteristica;
